/* Shortlist Tray — quantity and remove, against Shopify's cart AJAX API.
   No prices are read or rendered here: this store quotes, it does not sell. */
(function () {
  'use strict';

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart update failed (' + r.status + ')');
      return r.json();
    });
  }

  function flash(line, message) {
    var existing = line.querySelector('.sp-tray-error');
    if (existing) existing.remove();
    var el = document.createElement('p');
    el.className = 'sp-tray-error';
    el.setAttribute('role', 'status');
    el.textContent = message;
    line.appendChild(el);
  }

  function setQuantity(line, quantity) {
    line.classList.add('is-busy');
    return post('/cart/change.js', { id: line.dataset.spLine, quantity: quantity })
      .then(function () { window.location.reload(); })
      .catch(function () {
        line.classList.remove('is-busy');
        // Never fail silently — a buyer who thinks an item was removed and it wasn't
        // ends up with a shortlist they didn't intend to send.
        flash(line, 'That change did not save. Please try again.');
      });
  }

  document.addEventListener('click', function (event) {
    var line = event.target.closest('[data-sp-line]');
    if (!line) return;
    var input = line.querySelector('[data-sp-qty]');

    if (event.target.closest('[data-sp-remove]')) {
      event.preventDefault();
      setQuantity(line, 0);
      return;
    }
    if (event.target.closest('[data-sp-qty-up]')) {
      event.preventDefault();
      setQuantity(line, (parseInt(input.value, 10) || 1) + 1);
      return;
    }
    if (event.target.closest('[data-sp-qty-down]')) {
      event.preventDefault();
      var next = (parseInt(input.value, 10) || 1) - 1;
      if (next < 1) return;
      setQuantity(line, next);
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-sp-qty]')) return;
    var line = event.target.closest('[data-sp-line]');
    var value = parseInt(event.target.value, 10);
    if (!value || value < 1) { event.target.value = 1; value = 1; }
    setQuantity(line, value);
  });
})();

/* Presentation only — the app owns the quote button now.

   Samita clones our checkout-shaped source and inserts the clone as a sibling
   (verified against the v3.3 bundle, T-28). The clone is already type="button",
   has no `name`, and carries the app's own click handler, so it needs nothing
   from us to work.

   This does two small things:
     • hides the fallback once the real clone appears
     • explains itself if the clone never appears

   The previous version polled for ten seconds trying to "activate" a button.
   That was built on the wrong model — the app clones rather than mutates — and
   it kept selecting the original node instead of the clone, because both matched
   the same selector and the original comes first in the DOM. */
(function () {
  'use strict';

  var CLONE = '[class*="rfq-btn-cart"], [onclick*="addProductsCart"]';

  function sync() {
    var clone = document.querySelector(CLONE);
    var fallback = document.querySelector('[data-sp-quote-fallback]');
    if (!fallback) return;

    if (clone) {
      fallback.hidden = true;
      var n = document.querySelector('[data-sp-quote-note]');
      if (n) n.remove();
      return true;
    }
    return false;
  }

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  if (window.MutationObserver) {
    var host = document.querySelector('.sp-tray-side') || document.body;
    new MutationObserver(sync).observe(host, { childList: true, subtree: true });
  }

  // If the app never produces a button, say so rather than leaving the tray
  // looking like it should work.
  setTimeout(function () {
    if (sync()) return;
    var fallback = document.querySelector('[data-sp-quote-fallback]');
    if (!fallback || document.querySelector('[data-sp-quote-note]')) return;
    var note = document.createElement('p');
    note.className = 'sp-tray-note';
    note.setAttribute('data-sp-quote-note', '');
    note.textContent = 'Send us your shortlist and a commercial specialist will price it.';
    fallback.parentNode.insertBefore(note, fallback);
  }, 6000);
})();

/* Defence in depth: never let this form reach checkout.
   The source hook is type="button" so it cannot submit, but a stray Enter key in
   a text field can still submit a form. Every product is $0, so a submission
   that reached checkout would create a zero-value order. */
(function () {
  'use strict';
  var form = document.querySelector('form.sp-tray-form');
  if (!form) return;
  form.addEventListener('submit', function (e) { e.preventDefault(); });
})();

/* Clear the whole tray.
   Confirmed first: a facility buyer may have spent twenty minutes assembling a
   40-line list, and an accidental click that wipes it silently is unforgivable. */
(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sp-clear]');
    if (!button) return;
    event.preventDefault();
    if (!window.confirm('Remove every item from your shortlist? This cannot be undone.')) return;
    button.disabled = true;
    button.textContent = 'Clearing…';
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'Could not clear — try again';
      });
  });
})();

/* Clear the shortlist once it has been handed to the quote app.

   The shortlist (Shopify cart) and the quote (the app's own browser storage)
   are two separate lists, and the handoff COPIES rather than moves. Left alone,
   a buyer ends up holding two identical lists, and removing a line on the quote
   page does not remove it here — so the next handoff resurrects it. Clearing on
   success is what keeps "shortlist" and "quote" meaning two different things.

   Two details that matter:

   • `keepalive: true`. The app redirects to its quote page immediately after
     its own click handler runs. A normal fetch would be cancelled mid-flight by
     that navigation and the cart would survive. keepalive lets the request
     outlive the document.

   • We do not race the app for the data. Per the v3.3 bundle (T-28), its
     handler iterates `GRFQConfigs.cartItems`, which was populated at page load
     and lives in memory — it does not re-read the cart at click time. So
     clearing the server-side cart cannot empty the quote it is building. */
(function () {
  'use strict';

  var CLONE = '[class*="rfq-btn-cart"], [onclick*="addProductsCart"]';

  document.addEventListener('click', function (event) {
    var button = event.target.closest(CLONE);
    if (!button) return;
    if (!document.querySelector('[data-sp-line]')) return;

    try { sessionStorage.setItem('spShortlistSent', String(Date.now())); } catch (e) {}

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      keepalive: true
    }).catch(function () {
      // The quote itself is already safe in the app's storage, so a failure here
      // is cosmetic: the buyer keeps a stale shortlist. Not worth interrupting
      // the handoff with an error.
    });
  }, true);
})();

/* Explain an empty shortlist the buyer just sent.

   Clearing silently means someone who navigates back to the tray finds it bare
   and reasonably concludes their work was lost. Same principle as the failure
   messages above: never let a deliberate action look like a malfunction. */
(function () {
  'use strict';
  var sent;
  try { sent = sessionStorage.getItem('spShortlistSent'); } catch (e) { return; }
  if (!sent) return;

  var empty = document.querySelector('[data-sp-empty]');
  if (!empty) return;

  // Only for the run of this visit — a shortlist rebuilt later is a fresh one.
  try { sessionStorage.removeItem('spShortlistSent'); } catch (e) {}

  var heading = empty.querySelector('h1, h2, h3');
  if (heading) heading.textContent = 'Your shortlist is with us';

  var note = document.createElement('p');
  note.className = 'sp-tray-note';
  note.textContent = 'We have your request. Start a new shortlist any time — a specialist will be in touch about the last one.';
  if (heading && heading.nextSibling) {
    heading.parentNode.insertBefore(note, heading.nextSibling);
  } else {
    empty.appendChild(note);
  }
})();
